import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { TruckHero } from './components/TruckHero';
import { SpecialOffers } from './components/SpecialOffers';
import { MenuSection } from './components/MenuSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-salsa selection:text-white" data-id="element-0" data-mp="3fa88j72bos5w">
      <SiteHeader data-id="element-1" data-mp="2rlynw8guiagc" />
      <main data-id="element-2" data-mp="2rl6un4aq0ot8">
        <TruckHero data-id="element-3" data-mp="2rit2p4bc7spw" />
        <SpecialOffers data-id="element-4" data-mp="2mluboumz01vx" />
        <MenuSection data-id="element-5" data-mp="2mmltn2nna13q" />
      </main>
      <SiteFooter data-id="element-6" data-mp="2mndna7xolord" />
    </div>;
}